import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const CropZoneBlockId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Input}
      id="cropZonePermitId"
      name="cropZonePermitId"
      placeholder="Enter crop zone block ID"
      label="Crop Zone Block ID"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default CropZoneBlockId;
